import CancelIcon from '@mui/icons-material/Cancel';
import "./ModalCloseBtn.scss"

interface ModalCloseBtnProps {
  handleCancel: Function
  disabled?: boolean
}

const ModalCloseBtn = (props: ModalCloseBtnProps) => {
  return (
    <CancelIcon className="modalCloseBtn" sx={{opacity: props.disabled ? 0.25 : 1}} onClick={() => {!props.disabled && props.handleCancel()}} />
  )
}

export default ModalCloseBtn